import Cookies from 'js-cookie';
import React from 'react';
import * as ReactRedux from 'react-redux';

import {receiveLoadingUpdate} from '../../../redux/actions';
// import store from 'store';
import Icon from './Icon';

const Sitefoot = (props) => {
  const config = props.config;
  const mobile = props.mobile || false;
  const meta = props?.meta|| {};
  const footerActive = props.footerActive || false;
  let copyright = null;
  if (config?.copyright) {
    copyright = `© ${config.copyright} | `;
  }

  const impressumAnchor = <a onClick={() => props?.changeLoading(true)} href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/impressum/'}>Impressum</a>;
  const datenschutzAnchor = <a onClick={() => props?.changeLoading(true)} href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/privacy/'}>Datenschutz</a>;
  const agbAnchor = <a onClick={() => props?.changeLoading(true)} href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/agb/'}>AGB</a>;
  let retourenAnchor = null;

  if (props?.meta?.conf?.retourenbestimmungen) {
    let tmp = ' | ';
    if (mobile) {
      tmp = '';
    }
    retourenAnchor = <>{tmp}<a onClick={() => props?.changeLoading(true)} href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/retouren/'}>Retouren</a></>;
  }

  let mobileUmschalten = null;
  if (props?.meta?.conf?.mobilAnsichtUmschalten && props?.meta?.licenseCache?.mobile && (props?.mobileBig || props?.mobile)) {
    if (!(Cookies?.get('DesktopVersionOnMobile')=='true')) {
      mobileUmschalten = <button  onClick={() => {
        Cookies.set('DesktopVersionOnMobile', true);
         location.reload();
      }}
        className={'changeAnsicht'}>Zur Desktopversion wechseln
      </button>;
    } else {
      mobileUmschalten = <button  onClick={() => {
        Cookies.set('DesktopVersionOnMobile', false);
         location.reload();
      }}
 className={'changeAnsicht'}>Zur Mobilversion wechseln
      </button>;
    }
  }
  if (mobile) {
    return <footer className={'_Sitefoot ' + (footerActive ? 'footerActive' : '')+ (props?.hidden ? 'hidden' : '')}>
      {mobileUmschalten}
      <div className='copyright'>{`© ${config.copyright}`}</div>
      <div className='grid'>
        {impressumAnchor}
        {agbAnchor}
        {datenschutzAnchor}
        {retourenAnchor}
      </div>
    </footer>;
  }
  return <footer className='_Sitefoot'>
    {mobileUmschalten}
    <section className='main'>
      <div className='inner'>
        <div className='brand'/>
        <div className='about'>
          {copyright}{impressumAnchor}&nbsp;|&nbsp;{agbAnchor}&nbsp;|&nbsp;{datenschutzAnchor}{retourenAnchor}
        </div>
        <a className='back-to-top' href='#top'>
          <Icon type='chevron-up'/>
        </a>
      </div>
    </section>
  </footer>;
};

export default ReactRedux.connect((state) => ({
  meta: state.meta,
  mobile: state.mobile.isMobile,
  mobileBig: state.mobileBig.isBig
}), (dispatch) => ({
  changeLoading: (loading) => {
    dispatch(receiveLoadingUpdate(loading));
  }
}))(Sitefoot);
